import {
  SET_REGISTRATION_INFO,
  RESET_REGISTRATION_INFO,
  SET_REGISTRATION_CURRENT_STEP,
  SIGN_UP,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  RESET_REGISTRATION_STATE,
} from './actionTypes';

export const setRegistrationInfo = info => ({
  type: SET_REGISTRATION_INFO,
  info,
});

export const resetRegistrationInfo = () => ({
  type: RESET_REGISTRATION_INFO,
});

export const setRegistrationCurrentStep = step => ({
  type: SET_REGISTRATION_CURRENT_STEP,
  step,
});

export const signUp = data => ({
  type: SIGN_UP,
  data,
});

export const signUpSuccess = () => ({
  type: SIGN_UP_SUCCESS,
});

export const signUpFailure = () => ({
  type: SIGN_UP_FAILURE,
});

export const resetRegistrationState = () => ({
  type: RESET_REGISTRATION_STATE,
});
